module.exports = __webpack_public_path__ + "static/media/trico2015.7ab86af4.jpg";